import React, { useContext, useEffect, useRef, useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { AuthContext } from '../../context/AuthContext';

const STORAGE_KEY = 'spid_cie_info_dismissed_v1';

export default function SpidCieInfoModal() {
  const { isAuth, user } = useContext(AuthContext);
  const [show, setShow] = useState(false);
  const [notShowAgain, setNotShowAgain] = useState(false);
  const prevIsAuth = useRef(isAuth);

  useEffect(() => {
    const wasAuth = prevIsAuth.current;
    prevIsAuth.current = isAuth;
    if (!wasAuth && isAuth && localStorage.getItem(STORAGE_KEY) !== 'true' && !user.isSpidUser)
      setShow(true);
  }, [isAuth, user.isSpidUser]);

  const handleClose = () => {
    if (notShowAgain) localStorage.setItem(STORAGE_KEY, 'true');
    setShow(false);
  };

  if (!isAuth) return null;

  return (
    <Modal show={show} onHide={handleClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Accesso alla piattaforma con SPID / CIE</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Si informa il personale sanitario della piattaforma Screening Neonatale e CEDAP della
          Regione Campania che, a partire da oggi 10 Marzo 2026, è disponibile la nuova modalità di
          accesso tramite <strong>SPID</strong> o{' '}
          <strong>CIE (Carta d&apos;Identità Elettronica)</strong>.
        </p>
        <p>
          Il sistema di accesso tramite username e password resterà temporaneamente disponibile, ma
          sarà dismesso a partire dal <strong>1° settembre 2026</strong>.
        </p>
        <p>
          Si invita pertanto tutto il personale ad utilizzare fin da subito SPID o CIE per
          l&apos;accesso alla piattaforma.
        </p>
      </Modal.Body>
      <Modal.Footer className="d-flex align-items-center justify-content-between">
        <Form.Check
          type="checkbox"
          id="spid-cie-dont-show-again"
          label="Non mostrare più questo messaggio"
          checked={notShowAgain}
          onChange={(e) => setNotShowAgain(e.target.checked)}
        />
        <Button variant="primary" onClick={handleClose}>
          Ho capito
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
